import styles from "./LCatalogTwoColsLeft.module.css";

/**
 * LCatalogTwoColsLeft — catalog layout 2 kolumny: lewy sidebar + main column.
 *
 * **Struktura:**
 *   leftSidebar | (catalogContent -> belowCatalog)
 */
export function LCatalogTwoColsLeft({
  leftSidebar,
  catalogContent,
  belowCatalog,
}: LCatalogTwoColsLeftProps) {
  return (
    <div className={styles.root}>
      <aside className={styles.sidebar}>{leftSidebar}</aside>
      <div className={styles.mainColumn}>
        <div className={styles.content}>{catalogContent}</div>
        {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
      </div>
    </div>
  );
}

export type LCatalogTwoColsLeftProps = {
  leftSidebar: React.ReactNode;
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
};
